export const DISTRIBUTION_URL = 'https://d15q6k8l9pfut7.cloudfront.net/';

const loadEventImage = (event, type) => {
  return `${DISTRIBUTION_URL}events/${event._id}${event.CoverImageTimestamp}_${type}.jpg`;
};

export { loadEventImage };
